// extracted by mini-css-extract-plugin
export default {"projectTitle":"ProjectTitle_projectTitle__xjWmQ","projectTitle__text":"ProjectTitle_projectTitle__text__P0RAs font-md-bold"};